import session from "./session";

export default {
  getAccountAuditByID(id,config) {
    return session.get(`/accounts/${id}/audit/?order=desc&page=${config.paginationPage}&limit=${config.paginationLimit}`);
  },
  loadAccount(accountId) {
    return session.get(`/accounts/${accountId}/?age=y&payment_link=true`);
  },
  updateAccount: async (id, data) => {
    return session.patch(`/accounts/${id}/`, JSON.stringify(data));
  },
  async searchAccounts(value) {
    let res = await session.get(`/accounts/search/?querystring=${encodeURIComponent(value)}`);
    const response = res.data;
    return new Promise((resolve) => {
      resolve(response);
    });
  },
  async getRecentEditedAccounts() {
    return session.get(`/accounts/?sort=last_changed&order=desc`);
  },
  async getAccountNotes(accountId) {
    let res = await session.get(`/accounts/${accountId}/notes/`);
    const response = res.data;
    return new Promise((resolve) => {
      resolve(response);
    });
  },
  createAccountNote(accountId, data) {
    return session.post(`/accounts/${accountId}/notes/`,JSON.stringify({ ...data, type: "Billing" }));
  },
  getCRMUsers() {
    return session.get(`/crm-users/?limit=1000`);
  },
  sendBrochure(accountId, product_kind) {
    return session.post(
      `/accounts/${accountId}/actions/send-brochure/${product_kind}/`,
    );
  },
  getAccountBalance(accountId) {
    return session.get(`/accounts/${accountId}/balance/`);
  },
  checkAccountDetails(data) {
    return session.get(`/gateway/billing/tools/bank-account/?sort_code=${data.sort_code}&bank_acc_no=${data.bank_acc_no}`);
  },
  getAccountEscalation(id) {
    return session.get(`/accounts/${id}/escalation/`);
  },
  removeAccountEscalation(id) {
    return session.delete(`/accounts/${id}/escalation/`);
  },
  sendPaymentLinkEmail(id) {
    return session.post(`/accounts/${id}/actions/payment-link/`);
  },
  sendPaymentLinkSMS(id) {
    return session.post(`/accounts/${id}/actions/payment-link-sms/`);
  },
  sendAccStatement(id) {
    return session.post(`/accounts/${id}/actions/statement/`);
  },
  getCreditData(id) {
    return session.get(`/accounts/${id}/credit-control/`);
  },
  sendDDMandate(id) {
    return session.post(`/accounts/${id}/actions/dd-mandate/`);
  },
  sendContactRequest(id) {
    return session.post(`/accounts/${id}/actions/contact-request/`);
  },
  addEscalation(id, data) {
    return session.post(`/accounts/${id}/escalation/`, JSON.stringify(data));
  },
  sendPortalInvite(id) {
    return session.post(`/accounts/${id}/actions/portal-invite/`);
  },
  getCreditReasons() {
    return session.get(`/static-data/options/?object_kind=CreditNoteProposal`);
  },
  getDdMandateHistory({ account, options }) {
    return session.get(`/accounts/${account}/direct-debit-mandates/`, {
      params: {
        page: options.page,
        limit: options.itemsPerPage,
        order: 'desc'
      }
    });
  },
  getDDMandatePDF(id) {
    return session.get(`/direct-debit-mandates/${id}/pdf/`, { responseType: 'blob' });
  },
  resetCop(accountId) {
    return session.post(`/accounts/${accountId}/actions/reset-payee-stat/`);
  }
};
